<script setup>
import ShopTheLook from "~/components/organisms/ShopTheLook.vue";
import GreyBlock from "~/components/templates/GreyBlock.vue";

const props = defineProps({
  data: Object,
  settings: Object,
})
</script>

<template>
  <div class="fullwidth-breakout">
    <div style="padding-top: 60px; padding-bottom: 60px;">
      <div class="container">
        <ShopTheLook
          :preview="props.data?.shop_the_look?.file_cut"
          :image="props.data?.shop_the_look?.file"
          :products="props.data?.shop_the_look?.products"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.fullwidth-breakout {
  width: 100vw;
  margin-left: calc(50% - 50vw);

  @include mobile {
    .container {
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>
